import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';
import PhoneUsageSnapshot, { PhoneUsageFrame, errorText } from './PhoneUsageSnapshot';
import { fetchPhoneUsage, fetchPhoneUsageDetails } from './phoneUsageApi';
import { toSnapshot } from './captureMapping';

const IDLE_META = { status: 'idle', card: null, error: null };
const IDLE_USAGE = { status: 'idle', snapshot: null, audit: [], error: null };

export default class LoanPhoneUsage extends Component {
  static propTypes = {
    loanId: PropTypes.string.isRequired,
    loanNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isAdmin: PropTypes.bool.isRequired,
    api: PropTypes.shape({ fetchPhoneUsage: PropTypes.func, fetchPhoneUsageDetails: PropTypes.func }),
  };

  static defaultProps = {
    loanNumber: null,
    api: { fetchPhoneUsage, fetchPhoneUsageDetails },
  };

  state = { meta: IDLE_META, isOpen: false, usage: IDLE_USAGE };

  metaSeq = 0;
  usageSeq = 0;

  componentDidMount() {
    if (this.props.isAdmin) this.loadMeta();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loanId !== this.props.loanId || prevProps.isAdmin !== this.props.isAdmin) {
      this.metaSeq += 1;
      this.usageSeq += 1;
      this.setState({ meta: IDLE_META, isOpen: false, usage: IDLE_USAGE });
      if (this.props.isAdmin) this.loadMeta();
    }
  }

  componentWillUnmount() {
    this.metaSeq += 1;
    this.usageSeq += 1;
  }

  loadMeta = () => {
    const seq = ++this.metaSeq;
    this.setState({ meta: { ...IDLE_META, status: 'loading' } });
    this.props.api.fetchPhoneUsage(this.props.loanId).then(
      card => {
        if (seq !== this.metaSeq) return;
        this.setState({ meta: { status: 'ready', card, error: null } });
      },
      error => {
        if (seq !== this.metaSeq) return;
        this.usageSeq += 1;
        this.setState({ meta: { ...IDLE_META, status: 'error', error }, isOpen: false, usage: IDLE_USAGE });
      }
    );
  };

  loadUsage = () => {
    const seq = ++this.usageSeq;
    this.setState({ usage: { ...IDLE_USAGE, status: 'loading' } });
    this.props.api.fetchPhoneUsageDetails(this.props.loanId).then(
      body => {
        if (seq !== this.usageSeq) return;
        let snapshot;
        try {
          snapshot = body.snapshot && toSnapshot(body.snapshot);
        } catch (e) {
          this.setState({ usage: { ...IDLE_USAGE, status: 'error', error: { status: 'invalid' } } });
          return;
        }
        this.setState({ usage: { status: 'ready', snapshot, audit: body.audit, error: null } });
      },
      error => {
        if (seq !== this.usageSeq) return;
        this.setState({ usage: { ...IDLE_USAGE, status: 'error', error } });
      }
    );
  };

  open = () => {
    this.setState({ isOpen: true });
    this.loadUsage();
  };

  close = () => {
    this.usageSeq += 1;
    this.setState({ isOpen: false, usage: IDLE_USAGE });
  };

  renderMetaState() {
    const { meta } = this.state;
    if (meta.status === 'error') {
      return (
        <div className="phone-usage__status" role="alert" data-testid="phone-usage-meta-error">
          <span>{errorText(meta.error)} Náhradné ani ukážkové údaje sa nezobrazujú.</span>{' '}
          <Button size="small" onClick={this.loadMeta} data-testid="phone-usage-meta-retry">
            Skúsiť znova
          </Button>
        </div>
      );
    }
    return (
      <div className="phone-usage__status" role="status" data-testid="phone-usage-meta-loading">
        <Spin size="small" /> <span>Načítavam údaje o snímke z telefónu…</span>
      </div>
    );
  }

  render() {
    if (!this.props.isAdmin) return null;
    const { meta, isOpen, usage } = this.state;
    return (
      <div className="phone-usage-slot" data-testid="phone-usage-slot">
        {meta.status === 'ready' ? (
          <PhoneUsageSnapshot
            card={{ ...meta.card, loanNumber: this.props.loanNumber }}
            usage={usage}
            isOpen={isOpen}
            onOpen={this.open}
            onClose={this.close}
            onRetry={this.loadUsage}
          />
        ) : (
          <PhoneUsageFrame>{this.renderMetaState()}</PhoneUsageFrame>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loan-management/components/phone-usage/LoanPhoneUsage.js